const accountLogos = import.meta.glob("../../static/images/account-logos/*.png", {
  eager: true,
  import: "default"
});

export const getAccountLogo = accountId =>
  accountLogos[`../../static/images/account-logos/${accountId}.png`];
